"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftHoursBadge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const enums_1 = require("@bemlo/enums");
const constants_1 = require("../../../constants");
const elements_1 = require("../../../elements");
const SHIFT_HOURS_ICON_STYLES = Object.freeze({
    [enums_1.ShiftHours.DAY]: {
        color: constants_1.Color.MEDIUM_BLUE,
        backgroundColor: constants_1.Color.LIGHTER_BLUE,
        icon: 'DayIcon',
    },
    [enums_1.ShiftHours.EVENING]: {
        color: constants_1.Color.MEDIUM_RED,
        backgroundColor: constants_1.Color.LIGHTER_RED,
        icon: 'EveningIcon',
    },
    [enums_1.ShiftHours.NIGHT]: {
        color: constants_1.Color.VIOLET,
        backgroundColor: constants_1.Color.TRANSPARENT_PURPLE,
        icon: 'NightIcon',
    },
    [enums_1.ShiftHours.LONG]: {
        color: constants_1.Color.PINK,
        backgroundColor: constants_1.Color.LIGHTER_RED,
        icon: 'DayEveningIcon',
    },
});
const IconWrapper = (0, styled_1.default)(elements_1.Div) `
  border-radius: 999px;
  background-color: ${({ selected, backgroundColor }) => selected ? backgroundColor : constants_1.Color.GREY};
  padding: ${constants_1.theme.spacing['1']}px;
  width: fit-content;
  border: ${({ error }) => `1px solid ${error ? constants_1.Color.RED : 'transparent'}`};
`;
const ShiftHoursBadge = ({ shiftHours, setChecked, checked, disabled, error, }) => {
    const { icon, backgroundColor, color } = SHIFT_HOURS_ICON_STYLES[shiftHours];
    return ((0, jsx_runtime_1.jsx)(IconWrapper, { as: setChecked ? elements_1.Clickable : undefined, onClick: setChecked, backgroundColor: backgroundColor, selected: checked, disabled: disabled, styles: { gridArea: shiftHours }, error: error, children: (0, jsx_runtime_1.jsx)(elements_1.Icon, { size: "sm", color: checked ? color : constants_1.Color.DARKEST_MEDIUM_GREY, name: icon, design: "solid" }) }));
};
exports.ShiftHoursBadge = ShiftHoursBadge;
